module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/solid/eye.svg?f72e8dc27b40caf94238c2ac836da0a2";